import { JsonObject } from '@/lib/helpers';
import { ThreadSettingsModel } from '../thread/thread-settings.model';
import { PreferencesModel } from './preferences.model';
import { HomeModel } from './home.model';
import { ThreadHistoryModel } from './thread-history.model';
import { BaseModel, CreateBaseModel } from '../base.model';

export class UserSettingsModel extends BaseModel {
  portal: {
    thread: ThreadSettingsModel;
    preferences: PreferencesModel;
    home: HomeModel;
    threadHistory: ThreadHistoryModel[];
  };

  constructor(props: JsonObject = {}) {
    super();
    const portal = (props.portal as JsonObject) || {};
    const { thread, preferences, home, threadHistory } = portal;

    this.portal = {
      thread: new ThreadSettingsModel((thread as JsonObject) || {}),
      preferences: new PreferencesModel((preferences as JsonObject) || {}),
      home: new HomeModel((home as JsonObject) || {}),
      threadHistory: Array.isArray(threadHistory)
        ? (threadHistory as JsonObject[]).map((row) => new ThreadHistoryModel(row))
        : [],
    };
  }
}

export class CreateUserSettingsModel extends CreateBaseModel {
  portal: {
    thread: ThreadSettingsModel;
    preferences: PreferencesModel;
    home: HomeModel;
    threadHistory: ThreadHistoryModel[];
  };

  constructor(settings: UserSettingsModel) {
    super();
    this.portal = settings.portal;
  }
}
